import { FloorplanToolBase } from './FloorplanToolBase';
import { ViewModes } from '../../helpers';
import type { IViewConfig } from '../../types';

/**
 * Default (idle) tool of the floorplan persona's Wall tab: plain selection of
 * wall-sketch geometry — walls and, on Measured floors, the merged outline
 * ring edges (both via the inherited selection plumbing). Replaces the former
 * `outline_selection` no-op once the OUTLINE annotation was merged into the
 * wall sketch.
 */
export class WallSelectionTool extends FloorplanToolBase {

  /** Tab selection tool: show the floors elevation map for orientation/switching. */
  protected showsFloorBars(): boolean {
    return true;
  }
  readonly name = 'wall_selection';

  getViewConfig(): IViewConfig {
    return {
      views: [ViewModes.XRAY_2D, ViewModes.PLAN_2D_SKELETON, ViewModes.PERSPECTIVE_3D_RGB],
      defaultViewId: ViewModes.XRAY_2D.id,
    };
  }
}
